import React from 'react';
import { useTranslation } from 'react-i18next';
import { TablePaginationConfig } from 'antd';

import { IngestionSourceParametersType, IngestionSourceModelOutput } from '../../../../../../gamma-api';
import IbTypography from '../../../../../components/common/IbTypography';
import ResourceTable, { IResourceTableItem, ResourceTableField } from '../ResourceTable';
import SourceStatus from '../SourceStatus';

import './index.less';

import { MAIN_CLASS_NAME } from './const';

export interface ISourceBuildingProps {
  sourceLoading: boolean;
  pageLoading: boolean;
  source: IngestionSourceModelOutput;
  resources: IResourceTableItem[];
  resourcePagination: TablePaginationConfig;
  onResourcePaginationChange: (page: number) => void;
  onRestart?: () => void;
}

const SourceBuilding: React.FC<ISourceBuildingProps> = ({
  sourceLoading,
  pageLoading,
  source,
  resources,
  resourcePagination,
  onResourcePaginationChange,
  onRestart,
}) => {
  const rolling = sourceLoading || !!source.versions.rolling;

  const parametersType = source.versions.latest.source.parameters.type;
  const resourceFields = [];

  const { t } = useTranslation();

  if (
    parametersType === IngestionSourceParametersType.WebsiteUrls ||
    parametersType === IngestionSourceParametersType.WebsiteCrawler ||
    parametersType === IngestionSourceParametersType.Website
  ) {
    resourceFields.push(ResourceTableField.Name);
    resourceFields.push(ResourceTableField.Url);
    resourceFields.push(ResourceTableField.Volume);
    resourceFields.push(ResourceTableField.Status);
  } else if (parametersType === IngestionSourceParametersType.File) {
    resourceFields.push(ResourceTableField.Name);
    resourceFields.push(ResourceTableField.Size);
    resourceFields.push(ResourceTableField.Status);
  } else if (parametersType === IngestionSourceParametersType.Elma365) {
    resourceFields.push(ResourceTableField.Name);
    resourceFields.push(ResourceTableField.Volume);
    resourceFields.push(ResourceTableField.Status);
  } else if (parametersType === IngestionSourceParametersType.Confluence) {
    resourceFields.push(ResourceTableField.Name);
    resourceFields.push(ResourceTableField.Url);
    resourceFields.push(ResourceTableField.Volume);
    resourceFields.push(ResourceTableField.Status);
  } else {
    resourceFields.push(ResourceTableField.Name);
    resourceFields.push(ResourceTableField.Url);
    resourceFields.push(ResourceTableField.Size);
    resourceFields.push(ResourceTableField.Status);
  }

  const onStatusRestart = () => {
    !rolling && onRestart?.();
  };

  return (
    <div className={MAIN_CLASS_NAME}>
      <IbTypography.Paragraph strong>
        {t('Source building: Title', { value: sourceLoading ? '?' : resourcePagination.total ?? resources.length })}
      </IbTypography.Paragraph>
      <SourceStatus
        action={source.versions.latest.source.instruction.action}
        direction="horizontal"
        loading={sourceLoading}
        problem={source.problem}
        rolling={rolling}
        stage={source.stage}
        status={source.status}
        stepsStyle="compact"
        onRestart={onStatusRestart}
      />
      <ResourceTable
        fields={resourceFields}
        items={resources}
        pageLoading={pageLoading}
        pagination={resourcePagination}
        sourceLoading={sourceLoading}
        onPaginationChange={onResourcePaginationChange}
      />
    </div>
  );
};

export default SourceBuilding;
